import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-6 overflow-hidden bg-brand-dark" data-id="element-61">
      {/* Background subtle glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-brand-accent/5 blur-[120px] rounded-full pointer-events-none" aria-hidden="true" data-id="element-62" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-64">
          <h1 className="font-heading font-extrabold text-4xl md:text-6xl lg:text-7xl text-brand-accent uppercase leading-tight mb-6" data-id="element-65">
            El Protocolo Varonil 45+:
            <br className="hidden md:block" data-id="element-66" />
            <span className="text-brand-text" data-id="element-67">
              Recupera tu Energía y Vigor en 21 Días (Sin Gimnasio)
            </span>
          </h1>
          <h2 className="font-body text-lg md:text-2xl text-brand-muted max-w-3xl mx-auto leading-relaxed font-medium" data-id="element-68">
            El sistema de Optimización Metabólica Hormonal diseñado para el
            hombre latino en USA que trabaja duro pero se siente agotado al
            llegar a casa.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-brand-card border border-brand-surface rounded-xl p-8 md:p-10 shadow-2xl mb-12" data-id="element-69">
          <div className="prose prose-invert max-w-none font-body text-brand-text text-lg leading-relaxed space-y-6" data-id="element-70">
            <p data-id="element-71">
              <strong className="text-brand-accent font-semibold" data-id="element-72">
                Son las 6:30 PM.
              </strong>{' '}
              Acabas de estacionar el auto frente a tu casa después de una
              jornada agotadora. En lugar de entrar con una sonrisa, te quedas
              sentado en silencio, mirando al vacío durante cinco minutos. No
              tienes energía para jugar con tus hijos, ni paciencia para
              conversar con tu esposa. Estás vacío.
            </p>
            <p data-id="element-73">
              Lo peor es que has empezado a creer que esto es "normal" a tu
              edad. Que la barriga que no para de crecer y la neblina mental que
              te persigue en el trabajo son simplemente el costo de envejecer.{' '}
              <strong className="text-brand-red font-semibold" data-id="element-74">
                No lo son.
              </strong>
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex justify-center" data-id="element-75">
          <CTAButton href="#offer" data-id="element-76">
            Acceder al Protocolo Varonil 45+ Ahora
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}